import React from 'react';
import { theme } from 'styles';
import styled from 'styled-components';

export function Footer(props) {
  return <FooterWrap>Copyright 2024. Namowebiz, Inc. All rights reserved.</FooterWrap>;
}

const FooterWrap = styled.footer`
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 15;
  height: 40px;
  background-color: ${theme.colors.gray100};
  color: ${theme.colors.gray600};
  padding: 13.5px 36px;
  font-size: 11px;
  line-height: 1.2;
  min-width: 1600px;
  width: 100%;
`;
